import { useMemo } from 'react';
import { TableColumnType } from 'antd';
import { useTranslation } from 'react-i18next';

import { TaxRate } from 'types';
import { CompensationType, Namespace } from 'enums';
import { EditableNumber } from 'components/common';

export const useTaxesTableColumns = (
  loading: boolean,
  isEditing: (tax: TaxRate) => boolean,
  actionsColumn: TableColumnType<TaxRate>,
) => {
  const { t } = useTranslation(Namespace.Settings);

  return useMemo<TableColumnType<TaxRate>[]>(() => {
    return [
      {
        title: t('compensationType'),
        dataIndex: 'compensationType',
        render: (type: CompensationType) => t(type, { ns: Namespace.CompensationTypes }),
      },
      {
        title: t('taxRateIndividual'),
        dataIndex: 'rate',
        align: 'right',
        width: '200px',
        render: (rate: number, tax: TaxRate) => (
          <EditableNumber name="rate" value={rate} required editing={isEditing(tax)} disabled={loading} min={0} />
        ),
      },
      actionsColumn,
    ];
  }, [t, isEditing, actionsColumn, loading]);
};
